//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.ColorVariable
import com.tixforgigs.apax.models.CustomVariable
import com.tixforgigs.apax.models.FontVariable

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template config model
* 
* @param colors The list of colors
* @param fonts The list of fonts
* @param vars The list of custom vars
*/
@Serializable

data class ThemeData (


      /* The list of colors */
    @SerialName(value = "colors") @Required val colors: kotlin.collections.List<ColorVariable>,


      /* The list of fonts */
    @SerialName(value = "fonts") @Required val fonts: kotlin.collections.List<FontVariable>,


      /* The list of custom vars */
    @SerialName(value = "vars") val vars: kotlin.collections.List<CustomVariable>? = null


) {




  }

